import { Tooltip } from "@mui/material";

interface DashboardStatisticsProps {
  infoIcon?: any;
  text: any;
  tooltip?: string;
  stats?: any;
  style?:any
  noBoxShadow?:Boolean
}

function DashboardStatistics(props: DashboardStatisticsProps) {
  return (
    <div className="dashboardStats" style={{ marginTop: "2.5%" }}>
      <div className={`__container ${props.noBoxShadow ? "" : "bxShadow"}`} style={props.style}>
        <div style={{ display: props.infoIcon ? "flex" : "block" , justifyContent: "center"}}>
          <div className="_stats">{props.stats}</div>
          <Tooltip title={"" + props.tooltip}>
          <div className="_info">{props.infoIcon}</div>
          </Tooltip>
        </div>
        <div className="_text">{props.text}</div>
      </div>
    </div>
  );
}

export default DashboardStatistics;
